import createIcon from '../../createIcon';

/**
 * @component @name PriceCheck
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMTNWOUMxMSA4LjQ1IDEwLjU1IDggMTAgOEg2VjZIMTFWNEg4LjVWM0g2LjVWNEg1QzQuNDUgNCA0IDQuNDUgNCA1VjlDNCA5LjU1IDQuNDUgMTAgNSAxMEg5VjEySDRWMTRINi41VjE1SDguNVYxNEgxMEMxMC41NSAxNCAxMSAxMy41NSAxMSAxM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOC41OSAxMi41MkwxMi45MyAxOC4xN0wxMC4xIDE1LjM0TDguNjkgMTYuNzZMMTIuOTMgMjFMMjAgMTMuOTNMMTguNTkgMTIuNTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PriceCheck = createIcon('PriceCheck', [
  [
    'path',
    {
      d: 'M11 13V9C11 8.45 10.55 8 10 8H6V6H11V4H8.5V3H6.5V4H5C4.45 4 4 4.45 4 5V9C4 9.55 4.45 10 5 10H9V12H4V14H6.5V15H8.5V14H10C10.55 14 11 13.55 11 13Z',
      key: '1s0owx',
    },
  ],
  [
    'path',
    {
      d: 'M18.59 12.52L12.93 18.17L10.1 15.34L8.69 16.76L12.93 21L20 13.93L18.59 12.52Z',
      key: 'qrnfb',
    },
  ],
]);

export default PriceCheck;
